import { EBillingPeriodType } from "../../Enum/EBillingPeriodType"
import { EPlanCouponDiscountType } from "../../Enum/EPlanCouponDiscountType"
import { EPlanCouponApprovalStatus } from "../../Enum/EPlanCouponApprovalStatus"

export class AdminPlanCoupon {
  id: number

  code: string

  discountType: EPlanCouponDiscountType

  discountValue: number

  validFromUtc?: string

  validUntilUtc?: string

  maxUsageTotal?: number

  maxUsagePerCompany?: number

  restrictToPlanEntityId?: number

  restrictToPeriodType?: EBillingPeriodType

  restrictToCompanyEntityId?: number

  linkedResellerEntityId?: number

  isActive: boolean

  requestedByResellerEntityId?: number

  approvalStatus: EPlanCouponApprovalStatus

  rejectionReason?: string

  constructor(data: Partial<AdminPlanCoupon> = {}) {
    this.id = data.id ?? 0

    this.code = data.code ?? ""

    this.discountType = data.discountType ?? EPlanCouponDiscountType.Percentage

    this.discountValue = data.discountValue ?? 0

    this.validFromUtc = data.validFromUtc

    this.validUntilUtc = data.validUntilUtc

    this.maxUsageTotal = data.maxUsageTotal

    this.maxUsagePerCompany = data.maxUsagePerCompany

    this.restrictToPlanEntityId = data.restrictToPlanEntityId

    this.restrictToPeriodType = data.restrictToPeriodType

    this.restrictToCompanyEntityId = data.restrictToCompanyEntityId

    this.linkedResellerEntityId = data.linkedResellerEntityId

    this.isActive = data.isActive ?? true

    this.requestedByResellerEntityId = data.requestedByResellerEntityId

    this.approvalStatus = data.approvalStatus ?? EPlanCouponApprovalStatus.Approved

    this.rejectionReason = data.rejectionReason
  }
}
